"use client";

import React from "react";

const ComprehensiveDentalHealth: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        A Commitment to Comprehensive Dental Health at Smile4Me
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        At Smile4Me, we believe in a patient-centric approach to dental care. Our team takes the time to listen to your concerns and understand your unique dental needs. We&apos;re committed to providing personalized treatments using the latest technology and techniques to ensure that you receive the best possible results.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        We&apos;re not just focused on treating dental issues as they arise – we&apos;re dedicated to preventing them from happening in the first place. That&apos;s why we offer comprehensive preventive care, including fluoride treatments, dental sealants, and regular oral exams. Our goal is to help you maintain a healthy, confident smile for life.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        We&apos;re also proud to be an active member of our local community. We regularly participate in events and initiatives aimed at promoting oral health education and awareness. By working together with our patients and neighbors, we can create a healthier, happier Astoria – one smile at a time.
      </p>
    </div>
  );
};

export default ComprehensiveDentalHealth;